import { useMutation } from 'react-query'

import { createDaybookTransaction, CreateDaybookTransactionResponseData } from '../query-api'

interface UseCreateDaybookTransactionProps {
  onError?: () => void
  onSuccess?: (data: CreateDaybookTransactionResponseData) => void
}

export const useCreateDaybookTransaction = (props?: UseCreateDaybookTransactionProps) => {
  const { onError, onSuccess } = props || {}

  const {
    mutate: createTransaction,
    isLoading: isProcessing,
    ...rest
  } = useMutation(createDaybookTransaction, {
    onSuccess,
    onError,
  })

  return { createTransaction, isProcessing, ...rest }
}
